import { render, staticRenderFns } from "./billing-modal-invoices-crud-grid.vue?vue&type=template&id=736a3ef2&scoped=true&"
import script from "./billing-modal-invoices-crud-grid.ts?vue&type=script&lang=ts&"
export * from "./billing-modal-invoices-crud-grid.ts?vue&type=script&lang=ts&"
import style0 from "./billing-modal-invoices-crud-grid.scss?vue&type=style&index=0&id=736a3ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736a3ef2",
  null
  
)

export default component.exports